// extracted by mini-css-extract-plugin
module.exports = {"benefits":"styles_benefits__k7R9q","benefits__content":"styles_benefits__content__U9z5Y"};